import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router } from '@angular/router';
import { ResourceVm } from 'qp-ui-interface';
import { Observable, from } from 'rxjs';
import { DataService } from '../../data.service';
import { AdaptorData } from '../../storefront/AdaptorData';
import { TabService } from '../services/tabs/tab.service';
import { LocalStorageService } from '../services/storage/local-storage.service';
import { KEYS } from '../utils/constants/storage.constants';
import { StorefrontService } from '../../storefront/storefront.service';

@Injectable()
export class PlayerResolver implements Resolve<ResourceVm> {
  constructor(
    private readonly tabService: TabService,
    private readonly dataService: DataService,
    private readonly storefrontService: StorefrontService,
    private readonly router: Router,
    private readonly localStorage: LocalStorageService
  ) {}

  resolve(route: ActivatedRouteSnapshot): Observable<ResourceVm> | null {
    const id = route.params.id;
    const existingData = this.dataService.selectedCardData;

    // 1. If we already have the data (set by PlayerGuard or previous navigation), just return it
    if (existingData && existingData.id === id) {
      return from(Promise.resolve(existingData));
    }

    // 2. Otherwise, fetch it (fallback)
    const playerData = this.fetchPlayerData(route.params.type, route.params.id);
    return from(playerData);
  }

  private async fetchPlayerData(
    contentType: any,
    id: any
  ): Promise<ResourceVm> {
    const adaptorData: AdaptorData = {
      resourceType: contentType,
      resourceId: id,
      storefrontId: this.localStorage.getItem(KEYS.STOREFRONT_ID),
      tabId: this.dataService.activeTab,
      tabName: this.tabService.getCurrentTab()?.name,
    };

    const resourceVm = await this.storefrontService
      .fetchResourceDetails(adaptorData)
      .catch(() => {
        this.dataService.isFromDeeplink = false;
        this.dataService.setPendingDeeplinkUrl = null;
        this.router.navigate([this.dataService.homeTab || '/']);
        return Promise.reject();
      });
    if (!resourceVm) {
      this.router.navigate([this.dataService.homeTab]);
      return Promise.reject();
    }

    this.dataService.selectedCardData = resourceVm;

    return Promise.resolve(resourceVm);
  }
}
